<template>
    <div :class="placeholderClass">{{ instance.placeholder }}</div>
</template>

<script>
export default
{
    name    : 'Treeselect--placeholder',
    inject  : [ 'instance' ],
    computed:
    {
        placeholderClass()
        {
            const { instance } = this;

            return (
            {
                'vue-treeselect__placeholder'           : true,
                'vue-treeselect-helper-zoom-effect-off' : true,
                'vue-treeselect-helper-hide'            : instance.hasValue || instance.trigger.searchQuery,
            })
        }
    },

    /*
    render()
    {
        const { instance } = this;

        const placeholderClass =
        {
            'vue-treeselect__placeholder'           : true,
            'vue-treeselect-helper-zoom-effect-off' : true,
            'vue-treeselect-helper-hide'            : instance.hasValue || instance.trigger.searchQuery,
        }

        return (
            <div class={placeholderClass}>
                { instance.placeholder }
            </div>
        )
    }
    */
}
</script>
